export enum VersionState {
  Draft = 0,
  Master = 1,
  Superseded = 2,
  AwaitingEffectiveness = 3,
}
